import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IDynamicActionsBrickEntry } from 'src/app/components/bricks/dynamic-actions-brick/dynamic-actions-brick-configuration/dynamic-actions-brick-configuration';

export interface DynamicActionEvent {
   actionEntry: IDynamicActionsBrickEntry;
   isToggled: boolean;
   isTogglable: boolean;
}

@Component({
   selector: 'samweb-dynamic-action-button',
   templateUrl: './dynamic-action-button.component.html',
   styleUrls: ['./dynamic-action-button.component.scss'],
})
export class DynamicActionButtonComponent {
   @Input()
   public actionEntry: IDynamicActionsBrickEntry;
   @Input()
   public isTogglable: boolean;

   @Output()
   public dynamicActionClick = new EventEmitter<DynamicActionEvent>();

   selectedChange(isSelected: boolean) {
      if (!this.isTogglable) {
         return;
      }
      const isToggled = !isSelected;
      this.dynamicActionClick.emit({ actionEntry: this.actionEntry, isToggled: isToggled, isTogglable: this.isTogglable });
   }

   click() {
      if (this.isTogglable) {
         return;
      }
      this.dynamicActionClick.emit({ actionEntry: this.actionEntry, isToggled: false, isTogglable: this.isTogglable });
   }
}
